import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .bonnie-layout.mobile-rows-1,
    .bonnie-layout.mobile-rows-1.has-subheader {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];

      .subheader,
      .header,
      .cta-btn,
      .media,
      .description {
        grid-row: 2;
      }
    }

    /* The block sets align-items on the grid, which would collapse the shared
       rule inside its grid area; stretch it so the border-bottom lands at the
       block's bottom. */
    .horizontal-rule {
      align-self: stretch;
    }

    .bonnie-layout.mobile-rows-2 {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];

      .header,
      .cta-btn {
        grid-row: 2;
      }

      .media,
      .description {
        grid-row: 3;
      }
    }
    .bonnie-layout.mobile-rows-2.has-subheader {
      .subheader {
        grid-row: 2;
      }
      .header,
      .cta-btn,
      .media,
      .description {
        grid-row: 3;
      }
    }

    .bonnie-layout.mobile-rows-3 {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];

      .header,
      .cta-btn {
        grid-row: 2;
      }
      .media {
        grid-row: 3;
      }
      .description {
        grid-row: 4;
      }
    }
    .bonnie-layout.mobile-rows-3.has-subheader {
      .subheader {
        grid-row: 2;
      }
      .header,
      .cta-btn {
        grid-row: 3;
      }
      .media,
      .description {
        grid-row: 4;
      }
    }

    .bonnie-layout.mobile-rows-4,
    .bonnie-layout.mobile-rows-4.has-subheader {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];

      .subheader {
        grid-row: 2;
      }
      .header {
        grid-row: 3;
      }
      .media,
      .cta-btn {
        grid-row: 4;
      }
      .description {
        grid-row: 5;
      }
    }

    .bonnie-layout {
      max-width: 100%;
      align-items: end;
    }

    .subheader {
      font-size: var(--fs-caption);
      line-height: var(--lh-caption);
      letter-spacing: var(--ls-caption);
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .header {
      grid-column: 2 / 5;
      grid-row: 3;
    }

    .cta-btn {
      grid-column: 6 / 8;
      grid-row: 3;
      place-self: end;
    }

    .image {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .image.media {
      display: block;
      width: 100%;
    }

    .image img,
    .image video {
      width: 100%;
    }

    .video {
      grid-column: 2 / 8;
      grid-row: 4;
      width: 100%;
      position: relative;
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 5;
    }

    @media (min-width: 600px) {
      .bonnie-layout.mobile-rows-1,
      .bonnie-layout.mobile-rows-1.has-subheader,
      .bonnie-layout.mobile-rows-2,
      .bonnie-layout.mobile-rows-2.has-subheader,
      .bonnie-layout.mobile-rows-3,
      .bonnie-layout.mobile-rows-3.has-subheader,
      .bonnie-layout.mobile-rows-4,
      .bonnie-layout.mobile-rows-4.has-subheader {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding);
        align-items: start;

        .details-row {
          margin-bottom: var(--top-padding-height);
        }

        .subheader {
          grid-column: 3 / 6;
          grid-row: 2;
          margin-bottom: calc(10rem / var(--default-rem-px-count));
        }

        /* Header, description and CTA share a first baseline. */
        .header {
          grid-column: 3 / 7;
          grid-row: 3;
          align-self: baseline;
        }

        .description {
          grid-column: 8 / 11;
          grid-row: 3;
          align-self: baseline;
        }

        /* The button's label joins the row's baseline. */
        .cta-btn {
          grid-column: 12 / 14;
          grid-row: 3;
          place-self: baseline;
        }

        .video,
        .image {
          grid-column: 2 / 14;
          grid-row: 4;
        }
      }

      .subheader {
        font-size: var(--fs-body-small);
        line-height: var(--lh-body-small);
        letter-spacing: var(--ls-body-small);
      }
    }
  `,
];
